// extracted by mini-css-extract-plugin
export default {"Title":"Reservation_Title__7PogD","Pagination":"Reservation_Pagination__LDDAO","DisableContainer":"Reservation_DisableContainer__pJp6R"};